<template>
  <b-form-select
    v-model="selectedLang"
    :options="langs"
    value-field="key"
    text-field="value"
    @change="handleChange"
  />
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'

export default {
  name: 'SelectLanguage',
  components: {
    BFormSelect,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    currentLanguage: {
      type: String,
      default: 'fa',
    },
    value: {
      type: String,
    },
  },

  data() {
    return {
      selectedLang: this.currentLanguage,
      langs: [
        { key: 'fa', value: 'فارسی' },
        { key: 'ar', value: 'عربی' },
        { key: 'en', value: 'انگلیسی' },
      ],
    }
  },
  watch: {
    currentLanguage() {
      this.selectedLang = this.currentLanguage
    },
    value(val) {
      this.selectedLang = val
    },
  },
  methods: {
    handleChange(selectedLang) {
      this.$emit('change-selected-language', selectedLang)
      this.$emit('input', selectedLang)
    },
  },
}
</script>
